import { render } from "./DeleteBoardModal.vue?vue&type=template&id=78b54540"
import script from "./DeleteBoardModal.vue?vue&type=script&lang=js"
export * from "./DeleteBoardModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\projetos\\ethos-nps\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__